import React from 'react';
import { Trans } from 'react-i18next';
import { FAQItem } from './types';

export const CA_FAQS: FAQItem[] = [
  {
    id: 'remote-areas',
    titleKey: 'does_fi_work_in_remote_areas_and_the_bush',
    answerContent: (
      <Trans
        i18nKey="does_fi_work_in_remote_areas_and_the_bush_answer"
        components={{ strong: <strong />, br: <br /> }}
      />
    ),
  },
  {
    id: 'cold-winters',
    titleKey: 'how_does_fi_handle_cold_canadian_winters',
    answerContent: <Trans i18nKey="how_does_fi_handle_cold_canadian_winters_answer" components={{ br: <br /> }} />,
  },
  {
    id: 'data-storage',
    titleKey: 'is_my_data_stored_in_canada',
    answerContent: <Trans i18nKey="is_my_data_stored_in_canada_answer" components={{ br: <br /> }} />,
  },
  {
    id: 'membership-start',
    titleKey: 'when_does_my_fi_membership_start',
    answerKey: 'your_fi_membership_starts_when_you_activate_your_device_or_7_days_after_the_series_3_is_shipped',
  },
  {
    id: 'why-membership',
    titleKey: 'why_is_fi_a_membership',
    answerContent: (t) => (
      <>
        {t(
          'the_fi_membership_provides_a_lower_cost_way_for_customers_to_try_the_most_advanced_technology_for_their_dogs_without_a_high_upfront_cost_fi_also_believes_in_continuing_to_deliver_new_features_analytics_and_benefits_and_a_membership_model_allows_us_to_continue_investing_in_the_best_possible_customer_experience',
        )}
        <br />
        <br />
        {t(
          'your_membership_includes_unlimited_att_cellular_service_and_gps_access_as_well_as_a_family_plan_so_you_can_share_your_account_with_everyone_who_cares_for_your_dog',
        )}
      </>
    ),
  },
  {
    id: 'lower-monthly-payment',
    titleKey: 'can_i_lower_my_monthly_payment_cost',
    answerContent: (t) => (
      <>
        {t(
          'the_longer_you_commit_to_fi_the_lower_your_monthly_cost_once_you_are_a_member_you_can_always_switch_to_an_annual_membership_to_lock_in_savings_additionally_our_referral_program_gives_you_a_free_month_for_each_person_you_refer',
        )}
      </>
    ),
    showWhen: (context) => !context.freeTrialEnabled,
  },
  {
    id: 'lower-monthly-payment-with-trial',
    titleKey: 'can_i_lower_my_monthly_payment_cost',
    answerContent: (t) => (
      <>
        {t(
          'the_longer_you_commit_to_fi_the_lower_your_monthly_cost_once_you_are_a_member_you_can_always_switch_to_an_annual_membership_to_lock_in_savings_additionally_our_referral_program_gives_you_a_free_month_for_each_person_you_refer',
        )}
        <br />
        <br />
        {t('you_can_also_try_fi_before_becoming_a_member_with_our_free_trial')}
      </>
    ),
    showWhen: (context) => context.freeTrialEnabled === true,
  },
  {
    id: 'free-trial',
    titleKey: 'is_there_a_free_trial_available',
    answerKey: 'free_trial_faq_answer',
    showWhen: (context) => context.freeTrialEnabled === true,
  },
  {
    id: 'multi-pet-offer',
    titleKey: 'how_does_the_multi_pet_offer_work',
    answerKey: 'multi_pet_offer_faq_answer',
    showWhen: (context) => context.enrolledInPositionDiscount,
  },
  {
    id: 'commitment-period',
    titleKey: 'what_is_the_commitment_period_on_the_month_to_month_and_3_month_memberships',
    answerKey:
      'when_you_sign_up_for_fi_you_can_try_it_for_30_days_if_for_any_reason_you_decide_that_fi_is_not_for_you_you_can_return_your_fi_within_the_return_window_otherwise_the_month_to_month_and_3_month_memberships_have_a_minimum_commitment_of_6_months',
  },
  {
    id: 'new-hardware',
    titleKey: 'what_happens_when_a_new_generation_of_hardware_is_released',
    answerKey:
      'when_you_have_an_active_fi_membership_you_dont_have_to_worry_about_having_outdated_hardware_you_are_eligible_to_upgrade_to_the_latest_hardware_at_a_discounted_price',
  },
];
